import React, { useEffect, useRef } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import CaluFormInput from '@/components/formComponents/customFields/CaluFormInput'
import useLeadSubmitTracking from '@/hooks/useLeadSubmitTracking'
import { Grid } from '@mui/material'

import s from './styles.module.scss'

const StepEmailPassword = ({ fields }) => {
  const {
    trigger,
    control,
    formState: { touchedFields },
  } = useFormContext()

  const password = useWatch({ control, name: 'password' })
  const trackLeadSubmitted = useLeadSubmitTracking()
  const hasTrackedFormStart = useRef(false)

  useEffect(() => {
    if (touchedFields.email && !hasTrackedFormStart.current) {
      hasTrackedFormStart.current = true
      trackLeadSubmitted({ event: 'form_start' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [touchedFields.email])

  useEffect(() => {
    if (touchedFields.repeatPassword) {
      // ✅ Solo si ya tocaron "repeatPassword", lo revalidamos
      trigger('repeatPassword')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password, touchedFields.repeatPassword])
  return (
    <Grid container className={s.gridContainer}>
      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput name={fields.email.name} labelText={fields.email.labelText} />
      </Grid>
      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput
          name={fields.password.name}
          labelText={fields.password.labelText}
          helperText={fields.password.helperText}
          type="password"
        />
      </Grid>
      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput
          name={fields.repeatPassword.name}
          labelText={fields.repeatPassword.labelText}
          helperText={fields.repeatPassword.helperText}
          type="password"
        />
      </Grid>
    </Grid>
  )
}

export default StepEmailPassword
